export default {
    namespaced: true,
    state: {
        documents_filters: null,
    },
    mutations: {
        updateDocumentsFilters(state, filters) {
            state.documents_filters = filters ? {
                timestamp_after: filters.timestamp_after,
                timestamp_before: filters.timestamp_before,
                customer_store_id: +filters.customer_store_id === 0 ? null : filters.customer_store_id,
                customer_pos_id: +filters.customer_pos_id === 0 ? null : filters.customer_pos_id,
            } : null;
        }
    },
    getters: {
        documents_filters: state => state.documents_filters
    },
};
